export default "__VITE_ASSET__xuWYd2K$__"